import React from 'react'
import RightPage1 from '../../Component/RightPage1/RightPage1'
import Rightpage2 from '../../Component/RightPage2/Rightpage2'
import RightPage3 from '../../Component/RightPage3/RightPage3'
import RightPage4 from '../../Component/RightPage4/RightPage4'
import RightPage5 from '../../Component/RightPage5/RightPage5'
import RightPage7 from '../../Component/RightPage7/RightPage7'
import RightPage6 from '../../Component/RightPage6/RightPage6'
import RightPage8 from '../../Component/RightPage8/RightPage8'
import RightPage9 from '../../Component/RightPage9/RightPage9'


const RightPage = () => {
  return (
    <div className='w-[100%] h-screen overflow-y-auto'>
      <RightPage1 />
      <Rightpage2 />
      <RightPage3 />
      <RightPage4 />
      <RightPage5 />
      <RightPage7 />
      <RightPage6 />
      <RightPage8 />
      <RightPage9 />
      
    </div>
  )
}

export default RightPage
